import React from 'react'

const Sixty_three = () => {
    return (
        <div className='container'> 
            <h1>C - recursive permutations in lexicographical order</h1>
            <div className='containers'>
           <code className='library'> #include </code>&lt;ctype.hd&gt;<br/>
           <code className='library'>#include</code> &lt;stdio.hd&gt;<br/>
           <code className='library'>#include</code> &lt;string.hd&gt;<br/>
           <code className='library'>#include</code> &lt;errno.hd&gt;<br/>

           <code className='library'>static void</code> recursion(char *str, size_t n, size_t max) &#123; <br/>
           <code className='keywords'> if</code> (n &lt; max) &#123; <br/>
           <code className='keywords'>  recursion</code>(str, n + 1, max);<br/>
           <code className='keywords'>for</code> (size_t i = n + 1; i &lt; max; i++) &#123; <br/>
           <code className='function'>  char</code> tmp = str[i];<br/>
      str[i] = str[n];<br/>
      str[n] = tmp;<br/>
      <code className='function'>  recursion</code>(str, n + 1, max);<br/>
      str[n] = str[i];<br/>
      str[i] = tmp;
    &#125; <br/><br/>
  &#125; <br/>   <code className='keywords'>else</code> &#123; <br/>
  <code className='library'>   printf</code>("%s\n", str);<br/>
  &#125; <br/>
&#125; <br/>

<code className='keywords'>int</code> main(void) &#123; <br/>
<code className='keywords'>char</code> str[42];<br/>
  errno = 0;<br/>
  <code className='keywords'> if</code> (scanf("%41s", str) != 1) &#123; <br/>
  <code className='keywords'> if</code> (errno != 0) &#123; <br/>
  <code className='function'>   perror</code>("scanf()");<br/>
    &#125; <br/> else &#123; <br/>
    <code className='function'>    fprintf</code>(stderr, "no input");<br/>
    &#125; <br/>
    <code className='library'> return</code>  1;<br/>
  &#125; <br/>

  <code className='function'>recursion</code>(str, 0, strlen(str));<br/>
&#125; <br/>
            </div>
        </div>
    )
}

export default Sixty_three
